const validators = {
  required: (value) => ({
    result: Boolean(value),
    message: 'This field is required!',
    priority: 100,
  }),
  mobile: (value) => {
    const regex = /^\d{10}$/;
    return {
      result: regex.test(value),
      message: 'Mobile number incorrect!',
      priority: 10,
    };
  },
};

export default (value, rulesToCheck) => {
  const rulesToCheckArr = rulesToCheck.split('|');
  let message = '';
  let priority = 0;
  rulesToCheckArr.forEach((rule) => {
    if (Object.prototype.hasOwnProperty.call(validators, rule)) {
      const test = validators[rule](value);
      if (!test.result && priority < test.priority) {
        priority = test.priority;
        message = test.message;
      }
    }
  });
  return message;
};



// WEBPACK FOOTER //
// ./src/utils/basicValidator.js